<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import type { GoldType } from '@/types/mall'
import { socketEmit, socketEmitAsync } from '@/utils/web-socket'
import { ref, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { formatNumberWithCommas } from '@/utils'

const userStore = useUserStore()

const goldList = ref<GoldType[]>()
const curGold = ref<GoldType>()
async function getGoldList() {
  socketEmit<GoldType[]>({
    type: 'getGoldCollection',
    callBack: (res) => {
      goldList.value = res.data
    },
  })
}
function handleBuyGold() {
  if (!curGold.value) return ElMessage.warning('未选中任何商品')
  const { id, gold, price } = curGold.value
  if (userStore.diamond < price) return ElMessage.warning('钻石不足')
  ElMessageBox.confirm(`确认购买金币【${formatNumberWithCommas(gold)}】吗？本次购买花费<b>${price}</b>钻石`, '提示', {
    type: 'warning',
    dangerouslyUseHTMLString: true,
    appendTo: 'body',
    confirmButtonClass: 'is-plain',
  })
    .then(async () => {
      await socketEmitAsync({ type: 'buyGold', data: { id } })
      userStore.diamond -= price
      const info = goldList.value!.find((item) => item.id === id)
      if (!info) return
      userStore.gold += info.gold
    })
    .catch(() => {})
}

onMounted(() => {
  getGoldList()
})
</script>

<template>
  <div class="mall-gold">
    <p class="common-coin-info">
      <span>💎 {{ formatNumberWithCommas(userStore.diamond) }}</span>
      <span style="margin-left: 8px">💰 {{ formatNumberWithCommas(userStore.gold) }}</span>
    </p>
    <div class="mall-gold-list-wrap border-wrap">
      <h4>商品列表</h4>
      <div class="mall-gold-list">
        <div class="item" v-for="item of goldList" :key="item.id">
          <el-button size="small" type="primary" plain @click="curGold = item">一{{ item.name }}金币</el-button>
        </div>
      </div>
    </div>
    <div class="mall-gold-detail border-wrap">
      <h4>商品详情</h4>
      <p>名称：{{ curGold?.name ? `一${curGold.name}金币` : '未选择' }}</p>
      <p>
        金币：<span>{{ formatNumberWithCommas(curGold?.gold || 0) }}</span>
      </p>
      <p>价格：{{ curGold?.price || 0 }}💎</p>
      <el-button type="primary" plain style="width: 100%" @click="handleBuyGold">购入</el-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mall-gold {
  height: 100%;
  display: flex;
  flex-flow: column nowrap;
  .border-wrap {
    padding: 10px;
  }
  .mall-gold-list-wrap {
    margin-bottom: 10px;
    overflow: auto;
    flex: 1;
    .mall-gold-list {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      .item {
        width: calc(50% - 5px);
        margin-bottom: 10px;
        button {
          width: 100%;
        }
      }
    }
  }
  .mall-gold-detail {
    p {
      margin: 6px 0;
      font-size: 14px;
    }
  }
  :deep() {
    .el-button:focus,
    .el-button:hover {
      background-color: unset;
    }
  }
}
</style>
